export default {
    page_title: "Kevi | Order Fields",
    list: {
        title: "Order fields",
        add_button: "Add",
        edit_tooltip: "Edit field",
        delete_tooltip: "Delete field",
    },
    form: {
        title: "Creating field",
        name_label: "Name",
        type_label: "Type",
        options_label: "Options",
        option_placeholder: "Option text",
        option_label: "Option {0}",
        remove_option: "Remove",
        add_option: "Add option",
        back_button: "Back",
        save_button: "Save",
    },
    edit_modal: {
        title: "Edit custom field",
        name_label: "Name",
        type_label: "Type",
        options_label: "Options",
        option_placeholder: "Option text",
        option_label: "Option {0}",
        remove_option: "Remove",
        add_option: "Add option",
    },
    confirm_delete: {
        title: "Would you like to delete",
        no_relations:
            "This action is irreversible, are you sure you want to continue?",
        linked_automations: "the following automations:",
        linked_segments: "the following segments:",
        linked_warning: "This field is linked to",
        warning_message:
            "It is recommended to adjust before removing, continuing now may generate unexpected results.",
    },
    confirm_edit_name: {
        title: "Would you like to edit the name to",
        body: "Make sure the new name is correct before confirming.",
    },
    notifications: {
        field_edited: "Order field edited",
        field_updated: "Field updated",
        field_added: "Field added",
        field_deleted: "Custom field deleted",
        min_options_warning: "You must add at least two filled options.",
    },
    sr: {
        name_label: "Name",
    },
};
